// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"353":"b803d380","476":"bbd40814"}[chunkId] + ".chunk.css";
};